<template>
  <div />
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    chartDataX: {
      type: Array,
    },
    chartDataY: {
      type: Array,
    },
    legendData: {
      type: Array,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      chart: null,
      legendselected: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      //解决数据还没初始化就初始化表格的bug
      setTimeout(() => {
        this.initChart();
      }, 200);
    });
    window.addEventListener("resize", this.windowResize);
  },
  methods: {
    windowResize() {
      //销毁图表重新画;
      setTimeout(() => {
        this.initChart();
      }, 100);
    },
    initChart() {
      if (this.$el.offsetHeight === 0) {
        return;
      }
      echarts.dispose(this.$el);
      this.chart = echarts.init(this.$el);
      this.setOptions();

      //添加legend的监听
      this.chart.on("legendselectchanged", (params) => {
        console.log(params.selected);
        if (params.name == "湿度") {
          this.$store.state.humiditySelected = params.selected["湿度"];
        }
      });
    },
    setOptions() {
      if (!this.chart) {
        return;
      }

      const _this = this;
      let that = this;
      this.chart.setOption(
        {
          tooltip: {
            trigger: "axis",
            confine: true, //解决提示框越界
            backgroundColor: "var(--tooltipcardbg-color)",
            borderWidth: 0, // 取消边框
            textStyle: {
              color: "#7F8488", // 设置字体颜色，可以使用颜色值或者颜色名称
            },
            formatter: (params) => {
              const a =
                this.title.includes("电机负载") &&
                this.chartDataX &&
                this.chartDataX.length > 0
                  ? "ap"
                  : this.title.includes("温度(°C)") &&
                    this.chartDataX &&
                    this.chartDataX.length > 0
                  ? "°C"
                  : "";
              //自定义提示框
              if (params.length > 0 && params[0].seriesName == "x") {
                let relVal = params[0].name;
                for (var i = 0, l = params.length; i < l; i++) {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    params[i].seriesName +
                    " : " +
                    params[i].value +
                    " °";
                }
                return relVal;
              } else {
                let relVal = params[0].name;
                for (var i = 0, l = params.length; i < l; i++) {
                  relVal +=
                    "<br/>" +
                    params[i].marker +
                    params[i].seriesName +
                    " : " +
                    '<span style="color:' +
                    "rgba(68, 215, 182, 1)" +
                    '">' +
                    params[i].value +
                    "</span>" +
                    a;
                }
                return relVal;
              }
            },
          },
          color: [
            "#5B8FF9",
            "#5AD8A6",
            "#5D7092",
            "#00d1ed",
            "rgb(255,149,74)",
            "rgb(255,243,105)",
            "rgb(136,255,195)",
            "#cf8680",
            "rgb(96,238,255)",
            "#d77fe1fa",
            "#FAAD14",
            "#52C41A",
            "#C0E9FF",
            "#7CA4CF",
            "#5BB3BC",
            "#6D7278",
          ],
          legend: {
            data: this.legendData,
            textStyle: { color: "#7F8488" },
            icon: "Rect",
            itemWidth: 30,
            itemHeight: 3,
            left: "50",
            selected: this.legendselected,
          },
          xAxis: {
            data: this.chartDataX,
            boundaryGap: false,
            axisLine: {
              lineStyle: { color: "#7F8488" },
            },
            axisLabel: {
              color: "#7F8488",
              formatter: (params) => {
                let time = new Date(params);
                const y = time.getFullYear();
                const m = time.getMonth() + 1;
                const d = time.getDate();
                const h = time.getHours();
                const mm = time.getMinutes();
                const s = time.getSeconds();
                if (this.showDate) {
                  return (
                    (h < 10 ? "0" + h : h) +
                    ":" +
                    (mm < 10 ? "0" + mm : mm) +
                    "\n" +
                    (m < 10 ? "0" + m : m) +
                    "-" +
                    (d < 10 ? "0" + d : d)
                  );
                } else {
                  return (
                    (h < 10 ? "0" + h : h) +
                    ":" +
                    (mm < 10 ? "0" + mm : mm) +
                    "\n" +
                    (m < 10 ? "0" + m : m) +
                    "-" +
                    (d < 10 ? "0" + d : d)
                  );
                }
              },
            },
          },
          yAxis: {
            splitLine: {
              show: true,
              lineStyle: { color: ["#244447"], width: 1, type: "dashed" },
            },
            axisLine: {
              lineStyle: { color: "#7F8488" },
            },
            name:
              this.title.includes("电机负载") &&
              this.chartDataX &&
              this.chartDataX.length > 0
                ? "ap"
                : this.title.includes("温度(°C)") &&
                  this.chartDataX &&
                  this.chartDataX.length > 0
                ? "°C"
                : "",
            nameTextStyle: {
              padding: [0, 15, 0, 0], // 自定义名称位置的偏移量
            },
          },
          grid: {
            top: "20%",
            left: "15px",
            right: "15px",
            bottom: "5px",
            containLabel: true,
          },
          series: this.chartDataY,
        },
        true
      );
    },
  },
  computed: {
    timeInterval: function () {
      if (this.title === "电机负载(ap)") {
        return this.$store.state.motorTimeRange;
      } else if (this.title === "倾角") {
        return this.$store.state.angleTimeRange;
      } else {
        return "1m";
      }
    },
  },
  watch: {
    chartDataY: {
      deep: true,
      handler: function () {
        this.setOptions();
        // this.windowResize();
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/stackedLineEchart.vue